import { render } from "./index.vue?vue&type=template&id=44598a4e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/apartment/building/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44598a4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44598a4e', __exports__)) {
    console.log('reload')
    api.reload('44598a4e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=44598a4e", () => {
    console.log('re-render')
    api.rerender('44598a4e', render)
  })

}


export default __exports__